import { createSelector } from 'reselect';
import Immutable from 'immutable';

import { getSelectedBUId } from 'common/redux/selectors/appPreferences';
import { TeamStatusEnum } from 'common/enums/TeamEnum';
import { clientIdSelector } from 'common/redux/selectors/sessionSelector';

const allTeamsSelector = createSelector(
    [clientIdSelector, state => state.team],
    (clientId, teamState) => {
        return teamState.getIn(['records', clientId], Immutable.Map());
    }
);

const allTeamsSortedByNameSelector = createSelector(
    [allTeamsSelector],
    allTeams => {
        return allTeams.sortBy(team => {
            return team.name
                ? team.name.toLowerCase()
                : team.teamId && team.teamId.toLowerCase();
        });
    }
);

const personnelTeamIdsSelector = createSelector(
    [state => state.session],
    session => {
        return session.getIn(
            ['session', 'personnel', 'teams'],
            Immutable.List()
        );
    }
);

const hasAllTeamsAccessSelector = state => {
    return state.session.getIn(
        ['session', 'personnel', 'hasAllTeamsAccess'],
        false
    );
};

export const personnelTeamsSelector = createSelector(
    [
        allTeamsSortedByNameSelector,
        personnelTeamIdsSelector,
        hasAllTeamsAccessSelector
    ],
    (allTeams, personnelTeamIds, hasAllTeamsAccess) => {
        if (allTeams.size === 0 || hasAllTeamsAccess) {
            return allTeams.toList();
        }
        const filteredTeams = allTeams.filter(team => {
            return (
                personnelTeamIds.findIndex(
                    teamId => teamId.teamId === team.teamId
                ) >= 0
            );
        });
        return filteredTeams.toList();
    }
);

export const personnelActiveTeamsSelector = createSelector(
    [personnelTeamsSelector],
    personnelTeams => {
        return personnelTeams.filter(
            team => team.get('status') !== TeamStatusEnum.Inactive
        );
    }
);

export const personnelActiveBUTeamsSelector = createSelector(
    [personnelActiveTeamsSelector, getSelectedBUId],
    (personnelTeams, selectedBU) => {
        if (!selectedBU) {
            return personnelTeams;
        }
        return personnelTeams.filter(
            team =>
                team.businessUnitId &&
                team.businessUnitId.businessUnitId === selectedBU
        );
    }
);

export const personnelBUTeamsSelector = createSelector(
    [personnelTeamsSelector, getSelectedBUId],
    (personnelTeams, selectedBU) => {
        if (!selectedBU) {
            return personnelTeams;
        }
        return personnelTeams.filter(
            team =>
                team.businessUnitId &&
                team.businessUnitId.businessUnitId === selectedBU
        );
    }
);

export const personnelActiveTeamValuesSelector = createSelector(
    [personnelActiveBUTeamsSelector],
    personnelActiveTeams => {
        const activeTeams = [];
        personnelActiveTeams.forEach(team => activeTeams.push(team.toJS()));
        return activeTeams;
    }
);

export const isFetchTeamInProgress = state => state.team.inProgress;

export default personnelTeamsSelector;
